export const CompanyDetails = {
  name: "Sandesh Mhatre",
};

export function getWebURL(webRequestType, functionName) {
  // const baseUrl = 'https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/';
  const baseUrl =
    "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_";
  // const baseUrl = 'https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/demo_';

  if (webRequestType == "vcare-ui") {
    return baseUrl + functionName;
  }
}

export async function ApiCall(json, webRequestType, functionName) {
  var x = getWebURL(webRequestType, functionName);
  console.log("X:", x);
  //  const responseFromApi=await fetch(x);
  // const dataFromApi=await responseFromApi.json();

  // console.log("Data from Api",dataFromApi);

  if (functionName == "vcare_calls") {
    const aa = "";
  }
  // var y = JSON.stringify(json);
  // console.log( "Json: ",JSON.stringify(json));

  if (Object.keys(json).length != 0) {
    //json["env"] = "DEV";
    json["env"] = "QA";
  } else {
    json = {};
    //json["env"] = "DEV";
    json["env"] = "QA";
  }
  // console.log( JSON.stringify(json));
  const res = await fetch(x, {
    method: "POST",
    //mode: 'no-cors',
    headers: {
      // Accept: 'application/plain',
      "Content-Type": "application/json",
      // 'Access-Control-Allow-Headers' : 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
      // 'Access-Control-Allow-Methods' : 'OPTIONS,POST',
      // 'Access-Control-Allow-Credentials' : true,
      // 'Access-Control-Allow-Origin' : '*',
    },
    body: JSON.stringify(json),
  }).catch(function (e) {
    console.log(e.message); // "oh, no!"
    return e;
  });
  var rjson = "";

  rjson = await res.json();

  console.log("Rjson:", rjson.body);
  return rjson;
}

export default { ApiCall };
